export const sellMode = () => {
    return { type: 'SELL_MODE' }
}
export const buyMode = () => {
    return { type: 'BUY_MODE' }
}